import util from '../../common/util';
function install(Vue) {
    let locationParams = {};
    if (!util.inNode()) {
        //  and koa consistent in 
        locationParams = {
            url: `${location.pathname}${location.search}`,
            origin: `${location.protocol}//${location.host}`,
            href: location.href.split('#')[0],
            path: location.pathname,
            pathname: location.pathname,
            query: util.getQueryField(),
            querystring: location.search.slice(1),
            hostname: location.hostname,
            protocol: location.protocol
        };
    }
    Vue.mixin({
        beforeCreate() {
            //  Component mixins _koaLocation,_isPageSpeed whether or not lighthouse Score agent 
            if (!util.inNode()) {
                this._koaLocation = locationParams;
                this._isPageSpeed = false;
            } else {
                // root
                const options = this.$parent ? this.$root : this.$options;
                const { _koaLocation, _isPageSpeed } = options;
                Object.assign(this, { _koaLocation, _isPageSpeed });
            }
        },
        created() {
            if (this.$parent && 'asyncDataLoaded' in this.$parent) {
                this.asyncDataLoaded = this.$parent.asyncDataLoaded;
            }
        },
        /**
         *  In order to be compatible with non-folding asyncData
         * ssr First screen rendering module  asyncDataLoaded = true  Avoid secondary calls from the client asyncData
         *  client non ssr asyncDataLoaded = false   transfer asyncData
         */
        beforeMount() {
            //  Modules that have already been rendered by the server do not need to be called again asyncData
            if (this.asyncDataLoaded) {
                return;
            }
            const isBlockRoot = this.isBlockRoot;
            const asyncData = this.$options.asyncData;
            if (typeof asyncData === 'function' && isBlockRoot) {
                const rootVm = this.$root;
                const modules = rootVm.moduleData;
                const moduleData = modules.find(item => this.id === item.id);
                this.asyncDataPromise = asyncData({
                    app: rootVm,
                    store: this.$store,
                    modules,
                    moduleData,
                    data: moduleData.data,
                    blockStoreName: this.$storeName,
                    isBlockRoot: true,
                    location: locationParams
                });
            } else {
                if (this.$parent && this.$parent.asyncDataPromise) {
                    this.asyncDataPromise = this.$parent.asyncDataPromise;
                }
            }
        }
    });
}

export default install;
